export const MAIN_ARTIST = 'main_artists'
export const FEATURING_ARTIST = 'featuring_artists'
export const MAIN_ARTIST_VOCALOID = 'main_vocaloid_artist'
export const FEATURING_ARTIST_VOCALOID = 'featuring_vocaloid_artist'
export const AUTHOR = 'authors'
export const ARTIST = 'artist'
export const VOCALOID = 'vocaloid'
export const LYRICIST = 'lyricist'
export const COMPOSER = 'composer'
export const FORM_TYPE = {
  COPYRIGHT: 'copyright',
  ARTIST: 'artist',
  AUTHOR: 'author',
}
